


















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import PxTextEntryBox from '@/views/components/input/formFields/PxTextEntryBox.vue';
import PxTextArea from '@/views/components/input/formFields/PxTextArea.vue';
import PxDropdown from '@/views/components/input/formFields/PxDropdown.vue';
import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';

import { perRoadStore } from '@/store/store';
import { states } from '@/lib/data/states';
import SeasonRow from '@/modules/perRoad/views/components/SeasonRow.vue';
import { UnitSystem } from '@/interfaces/units';
import { createPerRoadValidations } from '@/modules/perRoad/lib/validations';

Component.registerHooks(['validations']);

@Component({
  components: {
    SeasonRow,
    PxNumberInput,
    PxTextEntryBox,
    PxTextArea,
    PxDropdown,
  },
})
export default class PerRoadScenarioInfo extends Vue {
  // @Prop() readonly id!: string;

  @Prop() readonly page!: number;

  stateOptions = states;

  get scenario() {
    return perRoadStore.currentScenario;
  }

  get scenarioImperial() {
    return perRoadStore.currentImperial;
  }

  get isImperial() {
    return this.scenario.unitSystem === UnitSystem.Imperial;
  }

  sync() {
    perRoadStore.setCurrentScenario(this.scenario);
  }

  save() {
    this.sync();
    perRoadStore.saveCurrentScenario();
  }

  validations() {
    return createPerRoadValidations(this.scenarioImperial, this.page);
  }
}

